type MaskProps = {
  mask:
    | 'CPF'
    | 'CNPJ'
    | 'WithoutMask'
    | 'PhoneNumber'
    | 'CEP'
    | 'Number'
    | 'StateRegistration'
    | 'file'
    | 'Plate'
  value: any
}

export const maskNumber = (value: string) => {
  return (value || '').replace(/[^0-9]/g, '')
}

function maskPhoneNumber(value: string) {
  const cleanPhoneNumber = (value || '').replace(/\D/g, '')
  let PhoneNumberFormat =
    cleanPhoneNumber.length > 11
      ? cleanPhoneNumber.slice(0, 11)
      : cleanPhoneNumber

  return PhoneNumberFormat.replace(/^(\d{2})(\d)/g, '($1) $2').replace(
    /(\d)(\d{4})$/,
    '$1-$2'
  )
}

function CPF(value: string) {
  const cleanCPF = value || ''
  let cpfFormat = cleanCPF.length > 14 ? cleanCPF.slice(0, 14) : cleanCPF

  return cpfFormat
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1-$2')
}

function CNPJ(value: string) {
  const clean = (value || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

  // primeiros 12 = alfanumérico
  const base = clean.slice(0, 12).replace(/[^A-Z0-9]/g, '')

  // últimos 2 = somente números
  const digits = clean.slice(12, 14).replace(/\D/g, '')

  const finalValue = (base + digits).slice(0, 14)

  let formatted = ''

  for (let i = 0; i < finalValue.length; i++) {
    if (i === 2) formatted += '.'
    if (i === 5) formatted += '.'
    if (i === 8) formatted += '/'
    if (i === 12) formatted += '-'

    formatted += finalValue[i]
  }

  return formatted
}

function StateRegistration(value: string) {
  const cleanStateRegistration = (value || '').replace(/\D/g, '')
  let StateRegistrationFormat =
    cleanStateRegistration.length > 13
      ? cleanStateRegistration.slice(0, 13)
      : cleanStateRegistration

  return StateRegistrationFormat.replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
}
//999\.999\.999/9999     state registration

function CEP(value: string) {
  const cleanCep = (value || '').replace(/\D/g, '')
  let cepFormat = cleanCep.length > 8 ? cleanCep.slice(0, 8) : cleanCep

  return cepFormat.replace(/(\d{5})(\d)/, '$1-$2')
}

const valueMask = ({ mask, value }: MaskProps) => {
  if (!value) return

  switch (mask) {
    case 'CPF':
      return CPF(value)
    case 'CNPJ':
      return CNPJ(value)
    case 'CEP':
      return CEP(value)
    case 'WithoutMask':
      return value
    case 'Number':
      return maskNumber(value)
    case 'PhoneNumber':
      return maskPhoneNumber(value)
    case 'StateRegistration':
      return StateRegistration(value)

    default:
      return value
  }
}

export default valueMask
